const Getters = {
  getProductAndStockListFromState: (state) => {
    return state.productAndStockList
  },
  getProductListFromState: (state) => {
    return state.productList
  },
  getMakerListFromState: (state) => {
    return state.makerList
  }
}

export default Getters
